import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class StartOfPlay extends Fragment {
    summarize(summaryContext) {
        return new FragmentSummary("");
    }
}
